import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-primary/30 bg-primary/20 text-primary-foreground backdrop-blur-sm hover:bg-primary/30",
        secondary:
          "border-white/10 bg-black/30 text-high backdrop-blur-sm hover:bg-black/40",
        destructive:
          "border-destructive/30 bg-destructive/20 text-destructive backdrop-blur-sm hover:bg-destructive/30",
        outline: "border-white/20 text-foreground backdrop-blur-sm",
        success:
          "border-green-500/30 bg-green-500/20 text-green-400 backdrop-blur-sm hover:bg-green-500/30",
        warning:
          "border-yellow-500/30 bg-yellow-500/20 text-yellow-400 backdrop-blur-sm hover:bg-yellow-500/30",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(badgeVariants({ variant }), className)}
        {...props}
      />
    )
  }
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }